import React from 'react';
import { array, object, func } from 'prop-types';
import SocialsListItem from './SocialsListItem';

const propTypes = {
  socials: array.isRequired,
  accounts: object.isRequired,
  onUnsubscribe: func.isRequired,
};

const defaultProps = {
  socials: [],
  accounts: {},
};

const SocialsList = ({ socials, accounts, onUnsubscribe }) => (
  <div className="socials-list">
    {socials.length > 0 &&
      socials.map(social => (
        <SocialsListItem
          key={social.provider}
          {...social}
          account={accounts[social.provider]}
          onUnsubscribe={onUnsubscribe}
        />
      ))}
  </div>
);

SocialsList.propTypes = propTypes;
SocialsList.defaultProps = defaultProps;

export default SocialsList;
